import React, {useEffect, useState} from 'react';
import {useSelector} from 'react-redux';
import {getRequest} from '../../helpers/apiHandler';
import AdminCampaignHeading from "../PageHeadings/AdminCampaignHeading";
import AdminCampaignDatatable from '../DataTables/CampaignDatatable';

const ManagerSMSCampaign = () => {
  const { access_token } = useSelector((state) => state.auth.user);
  const [search, setSearch] = useState('');
  const [data, setData] = useState([]);

  const [dateRange, setDateRange] = useState('1_day');
  const [selectedRange, setSelectedRange] = useState('1 Day');

  const fetchData = () => {
    const data = {headers: {Authorization: access_token.token}};
    const params = {};

    if (search !== '') {
      params.search = search;
    }

    params.date_range = dateRange;

    getRequest('/admin/sms-campaign', {...data, params}, (res) => {
      if (res.success) {
        setData(res.data);
      } else {
        // TODO: Handle it later
      }
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchData();
  };

  useEffect(() => {
    // fetch the data from backend
    fetchData();
  }, [dateRange]);

  return (
    <div className="SMSCampaign h-100">
      <AdminCampaignHeading
        access_token={access_token}
        search={search}
        setSearch={setSearch}
        handleSearch={handleSearch}
        setDateRange={setDateRange}
        selectedRange={selectedRange}
        setSelectedRange={setSelectedRange}
        data={data}
      />
      <AdminCampaignDatatable
        data={data}
        dateRange={dateRange}
      />
    </div>
  );
};

export default ManagerSMSCampaign;
